// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__2gM1R","btnDefault":"style_btnDefault__1SDRN","logginButton":"style_logginButton__3Mc0k","loadingButton":"style_loadingButton__38pT_"};